// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-menu-button__button[data-v-7dc3d83f]{all:unset;display:flex;align-items:center;height:100%;padding:0 15px;font-size:16px}.login-menu-button__button--logged-in[data-v-7dc3d83f]{color:var(--ion-color-primary)}", ""]);
// Exports
module.exports = exports;
